export default "__VITE_ASSET__RAV6zYz8__"